/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Simple_Freegames1Inputs */

const id_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game Gratis`)
};

const ms_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permainan Percuma`)
};

const da_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis Spil`)
};

const de_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlose Spiele`)
};

const en_us2_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free Games`)
};

const es_es2_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos Gratis`)
};

const es_mx2_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos gratis`)
};

const fil_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libreng Laro`)
};

const fr_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeux gratuits`)
};

const it_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giochi Gratis`)
};

const hu_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingyenes játékok`)
};

const nl_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis Games`)
};

const no_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis spill`)
};

const pl_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darmowe gry`)
};

const pt_br2_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free Games`)
};

const pt_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos Grátis`)
};

const ro_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jocuri gratuite`)
};

const fi_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmaispelit`)
};

const sv_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis spel`)
};

const vi_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game miễn phí`)
};

const tr_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ücretsiz Oyunlar`)
};

const cs_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hry zdarma`)
};

const bg_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безплатни игри`)
};

const ru_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бесплатные игры`)
};

const uk_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безкоштовні ігри`)
};

const ar_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الألعاب المجانية`)
};

const hi_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मुफ़्त गेम`)
};

const th_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกมฟรี`)
};

const ja_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料ゲーム`)
};

const zh_cn2_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free Games`)
};

const zh_hant1_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free Games`)
};

const ko_notifications_simple_freegames1 = /** @type {(inputs: Notifications_Simple_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료 게임`)
};

/**
* | output |
* | --- |
* | "Free Games" |
*
* @param {Notifications_Simple_Freegames1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_simple_freegames1 = /** @type {((inputs?: Notifications_Simple_Freegames1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Simple_Freegames1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_simple_freegames1(inputs)
	if (locale === "ms") return ms_notifications_simple_freegames1(inputs)
	if (locale === "da") return da_notifications_simple_freegames1(inputs)
	if (locale === "de") return de_notifications_simple_freegames1(inputs)
	if (locale === "en-US") return en_us2_notifications_simple_freegames1(inputs)
	if (locale === "es-ES") return es_es2_notifications_simple_freegames1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_simple_freegames1(inputs)
	if (locale === "fil") return fil_notifications_simple_freegames1(inputs)
	if (locale === "fr") return fr_notifications_simple_freegames1(inputs)
	if (locale === "it") return it_notifications_simple_freegames1(inputs)
	if (locale === "hu") return hu_notifications_simple_freegames1(inputs)
	if (locale === "nl") return nl_notifications_simple_freegames1(inputs)
	if (locale === "no") return no_notifications_simple_freegames1(inputs)
	if (locale === "pl") return pl_notifications_simple_freegames1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_simple_freegames1(inputs)
	if (locale === "pt") return pt_notifications_simple_freegames1(inputs)
	if (locale === "ro") return ro_notifications_simple_freegames1(inputs)
	if (locale === "fi") return fi_notifications_simple_freegames1(inputs)
	if (locale === "sv") return sv_notifications_simple_freegames1(inputs)
	if (locale === "vi") return vi_notifications_simple_freegames1(inputs)
	if (locale === "tr") return tr_notifications_simple_freegames1(inputs)
	if (locale === "cs") return cs_notifications_simple_freegames1(inputs)
	if (locale === "bg") return bg_notifications_simple_freegames1(inputs)
	if (locale === "ru") return ru_notifications_simple_freegames1(inputs)
	if (locale === "uk") return uk_notifications_simple_freegames1(inputs)
	if (locale === "ar") return ar_notifications_simple_freegames1(inputs)
	if (locale === "hi") return hi_notifications_simple_freegames1(inputs)
	if (locale === "th") return th_notifications_simple_freegames1(inputs)
	if (locale === "ja") return ja_notifications_simple_freegames1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_simple_freegames1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_simple_freegames1(inputs)
	return ko_notifications_simple_freegames1(inputs)
});
export { notifications_simple_freegames1 as "notifications.simple.freeGames" }